// lib/metadata.js
import { getCurrentOrganization, getOrganizationPropertiesByHost } from './helpers';

// eslint-disable-next-line import/prefer-default-export
export const getMetadata = (pageName, hostname) => {
  let domainName;
  if (hostname) {
    domainName = getOrganizationPropertiesByHost(hostname);
  } else {
    domainName = getCurrentOrganization();
  }

  let titleDomainName;

  // console.log('hhhahah', domainName.organizationName);

  if (domainName.organizationName === 'nextias') {
    titleDomainName = 'nextias.com';
  } else if (domainName.organizationName === 'madeeasyprime' || domainName.organizationName === 'madeeasy') {
    titleDomainName = 'madeeasy.in';
  } else {
    titleDomainName = 'meniit.com';
  }

  const generatePageMetadata = (additionalTitle = '') => ({
    title: `${additionalTitle} | ${titleDomainName}`,
    description: `Welcome to the ${additionalTitle} page of ${titleDomainName}`,
  });

  const metadata = {
    home: generatePageMetadata('Home'),
    mycourse: generatePageMetadata('My Course'),
    courseDetails: generatePageMetadata(''),
    allCourses: generatePageMetadata('All Courses'),
    Notes: generatePageMetadata('Notes'),
    DailyNewsAnalysis: generatePageMetadata('Daily News Analysis'),
    DailyCAMCQs: generatePageMetadata('Daily CA MCQs'),
    PopularVideos: generatePageMetadata('Popular Videos'),
    StrategyVideos: generatePageMetadata('Strategy Videos'),
    StudyPlan: generatePageMetadata(''),
    SubjectDetail: generatePageMetadata(''),
    Attendance: generatePageMetadata('Attendance'),
    Bookmarks: generatePageMetadata('Bookmarks'),
    courseCombo: generatePageMetadata('Course Combo'),
    CustomerSupport: generatePageMetadata('Customer Support'),
    OrderHistory: generatePageMetadata('Order History'),
    Account: generatePageMetadata('Account'),
    Settings: generatePageMetadata('Settings'),
    Profile: generatePageMetadata('User Profile'),
    flexiCourseSelection: generatePageMetadata('Flexi Course Selection'),
    // Use the function for dynamic pages, like blog posts
    blogPost: (title) => generatePageMetadata('Blog Post', title),
  };
  // const metadata = {
  //   [pageName]: {
  //     title: `Home | ${TitleDomainName}`,
  //     description: '',
  //   },
  //   myCourse: {
  //     title: `My Course | ${TitleDomainName}`,
  //     description: '',
  //   },
  //   courseDetails: {
  //     title: `CourseDetails | ${TitleDomainName}`,
  //     description: '',
  //   },
  //   AllCourse: {
  //     title: `All Courses | ${TitleDomainName}`,
  //     description: '',
  //   },
  //   Notes: {
  //     title: `Notes | ${TitleDomainName}`,
  //     description: '',
  //   },
  //   DailyNews: {
  //     title: `${TitleDomainName}`,
  //     description: '',
  //   },
  //   blogPost: (title) => ({
  //     title: `${title} | ${TitleDomainName}`,
  //     description: `Read our latest blog post: ${title}`,
  //   }),
  // };
  return metadata[pageName] || metadata.home;
};
